export const storeItems =[
    {
        item:"stats",
        storeType:"character",
        price:75,
        defaultAmount:6,
        canBeSpecific:true,        
        specificType:"stats",
        typesArr:{abilityScore:false, skills:false, misc:false},
        options:{rarity:{common: true, rare: true, epic: true, legendary: true,unique:true,}, type:{ abilityScore:true, skills:true, misc:true}}
    },
    {
        item:"Reroll Hit Points",
        storeType:"character",
        price:50,
        defaultAmount:2,
        canBeSpecific:false,
        desc:`Reroll all hit point rolls (except your first)`,
    },
    {
        item:"armor",
        storeType:"equipment",
        price:50,
        defaultAmount:6,
        canBeSpecific:true,
        canBeTyped:true,
        specificType:"armor",
        typesArr:{clothing:false, light:false,medium:false,heavy:false,shield:false},
        options:{
            armor: {
                type:{clothing:true, light: true, medium: true, heavy: true, shield: true},
                rarity:{common: true, rare: true, epic: true, legendary: true, unique:true},                
              },
              armorEnchantments: {
                common: true, rare: true, epic: true, legendary: true, unique: true,
              },
        }
    },
    {
        item:"weapon",
        storeType:"equipment",
        price:50,
        defaultAmount:6,
        canBeSpecific:true,
        canBeTyped:true,
        specificType:"weapon",
        typesArr:{augmenting:false, light: false, oneHanded:false, twoHanded:false, primitive:false, tech:false,armament:false},
        options:{ 
            weapon: {
                rarity:{ common: true, rare: true, epic: true, legendary: true, unique:true}, 
                class:{ enchanted: false}, 
                type:{ augmenting:true, light: true, oneHanded:true, twoHanded:true, primitive:true, tech:true, armament:true}
            },
            weaponEnchantments: { 
                rarity:{ common: true, rare: true, epic: true, legendary: true, unique: true}, 
                class: { melee: true, ranged: true, armament: true, all: true}
            },
        }
    },
    {
        item:"enchanted weapon",
        storeType:"equipment",
        price:100,
        defaultAmount:4,
        specificType:"weapon",
        canBeSpecific:true,
        canBeTyped:true,
        typesArr:{ augmenting:false, light: false, oneHanded:false, twoHanded:false, primitive:false, tech:false,armament:false},
        options:{ 
            weapon: {
                rarity:{ common: true, rare: true, epic: true, legendary: true, unique:true}, 
                class:{ enchanted: true},
                type:{ augmenting:true, light: true, oneHanded:true, twoHanded:true, primitive:true, tech:true, armament:true}
            },
            weaponEnchantments: { 
                rarity:{ common: true, rare: true, epic: true, legendary: true, unique: true}, 
                class: { melee: true, ranged: true, armament: true, all: true}
            },
        }
    },
    {
        item:"enchanted armor",
        storeType:"equipment",
        price:100,
        defaultAmount:4,
        canBeSpecific:true,
        canBeTyped:true,
        specificType:"armor",
        typesArr:{clothing:false, light:false,medium:false,heavy:false,shield:false},
        options:{
            armor: {
                type:{clothing:true, light: true, medium: true, heavy: true, shield: true},
                rarity:{common: true, rare: true, epic: true, legendary: true, unique:true},
                enchanted: true,
              },
              armorEnchantments: {
                common: true, rare: true, epic: true, legendary: true, unique: true,
              },
        }
    },
    {
        item:"weapon enchantment",
        storeType:"equipment",
        price:125,
        defaultAmount:4,
        canBeSpecific:false,
    },
    {
        item:"armor enchantment",
        storeType:"equipment",
        price:125,
        defaultAmount:4,
        canBeSpecific:false,
    },
    {
        item:"Item Trade",
        storeType:"equipment",
        price:125,
        defaultAmount:1,
        canBeSpecific:false,
    },
    {
        item:"Perk",
        storeType:"perk",
        price:150,
        defaultAmount:4,
        canBeSpecific:true,
        canBeTyped:true,
        specificType:"perks",
        typesArr:{martial: false, magic: false, universal: false},
        options:{            
            type:{martial: true, magic: true, universal: true},
            rarity:{ common: true, rare: true, epic: true, legendary: true, unique: true},
            sub:{}
        },
    },
    {
        item:"Rage Power",
        storeType:"perk",
        price:150,
        defaultAmount:1,
        canBeSpecific:true,
        specificType:"perks",
        options:{            
            type:{martial: true, magic: true, universal: true},
            rarity:{ common: true, rare: true, epic: true, legendary: true, unique: true},
            sub:{ragePerks:true}
        },
    },
    {
        item:"Rogue Talent",
        storeType:"perk",
        price:150,
        defaultAmount:1,
        canBeSpecific:true,
        specificType:"perks",
        options:{            
            type:{martial: true, magic: true, universal: true},
            rarity:{ common: true, rare: true, epic: true, legendary: true, unique: true},
            sub:{roguePerks:true}
        },
    },
    {
        item:"Ki Power",
        storeType:"perk",
        price:150,
        defaultAmount:1,
        canBeSpecific:true,
        specificType:"perks",
        options:{            
            type:{martial: true, magic: true, universal: true},
            rarity:{ common: true, rare: true, epic: true, legendary: true, unique: true},
            sub:{kiPerks:true}
        },
    },
    {
        item:"Fighter Perk",
        storeType:"perk",
        price:200,
        defaultAmount:1,
        canBeSpecific:true,
        specificType:"perks",
        options:{            
            type:{martial: true, magic: true, universal: true},
            rarity:{ common: true, rare: true, epic: true, legendary: true, unique: true},
            sub:{fighterPerks:true}
        },
    },
    {
        item:"Recovery Perk",
        storeType:"perk",
        price:200,
        defaultAmount:1,
        canBeSpecific:true,
        specificType:"perks",
        options:{            
            type:{martial: true, magic: true, universal: true},
            rarity:{ common: true, rare: true, epic: true, legendary: true, unique: true},
            sub:{recoveryPerks:true}
        },
    },
    {
        item:"Feat",
        storeType:"character",
        price:125,
        defaultAmount:4,
        canBeTyped:true,
        specificType:"feats",
        typesArr:{martial: false, magic: false, utility: false, style:false},
    },
    {
        item:"Specific Feat",
        storeType:"character",
        specific:true,
        specificType:"feats",
        options:{martial:true, magic:true, utility:true, style:true, metamagic:true, key:true},
        price:150,
        defaultAmount:4
    },
    {
        item:"Specific Martial Feat",
        storeType:"character",
        specific:true,
        specificType:"feats",
        options:{martial:true, key:true},
        price:150,
        defaultAmount:2
    },
    {
        item:"Specific Magic Feat",
        storeType:"character",
        specific:true,
        specificType:"feats",
        options:{magic:true, style:true, metamagic:true, key:true},
        price:150,
        defaultAmount:2
    },
    {
        item:"Teamwork Feat",
        storeType:"character",
        price:250,
        defaultAmount:2,
    },
    {
        item:"Spell",
        storeType:"spells/maneuvers",
        price:40,
        defaultAmount:8,
        canBeSpecific:true,
        specificType:"spells",
        options:{
            level:{},
            type:{damage:true, control:true, utility:true, buff:true, healing:true},
        }
    },
    {
        item:"Typed Spell",
        storeType:"spells/maneuvers",
        price:60,
        defaultAmount:4,
        canBeSpecific:false,
    },
    {
        item:"Maneuver",
        storeType:"spells/maneuvers",
        price:40,
        defaultAmount:8,
        canBeSpecific:true,
        specificType:"maneuver",
        options:{
            level:{},
            type:{Boost: true, Stance: true, Strike: true, Counter: true, Finisher:true},
            school:{blackSeraph: true, brokenBlade: true, brutalCrocodile: true, burningCitadel: true, crimsonReaper: true, cursedRazor: true, elementalFlux: true, eternalGuardian: true, goldenLion: true, heartOfTheMaelstrom: true, indomitableWill: true, ironTortoise: true, mithralCurrent: true, piercingThunder: true, primalFury: true, radiantDawn: true, rivenHourglass: true, scarletThrone: true, shadowAssassin: true, shatteredMirror: true, silverCrane: true, sleepingGoddess: true, solarWind: true, steelSerpent: true, sterlingSovereignty: true, tempestGale: true, thrashingDragon: true, unquietGrave: true, veiledMoon: true,}
        }
    },
    {
        item:"Finisher",
        storeType:"spells/maneuvers",
        price:60,
        defaultAmount:10,
        canBeSpecific:true,
        canBeTyped:true,
        specificType:"maneuver",
        typesArr:{Air:false, Arcane:false, Curse:false, Dark:false, Death:false, Earth:false, Fire:false, Flurry:false, Guardian:false, Heroic:false, Light:false, Power:false, Primal:false, Royal:false, Sakura:false, Shadow:false, Technique:false, Void:false, Water:false},
        options:{
            level:{},
            type:{Finisher:true},
            school:{blackSeraph: true, brokenBlade: true, brutalCrocodile: true, burningCitadel: true, crimsonReaper: true, cursedRazor: true, elementalFlux: true, eternalGuardian: true, goldenLion: true, heartOfTheMaelstrom: true, indomitableWill: true, ironTortoise: true, mithralCurrent: true, piercingThunder: true, primalFury: true, radiantDawn: true, rivenHourglass: true, scarletThrone: true, shadowAssassin: true, shatteredMirror: true, silverCrane: true, sleepingGoddess: true, solarWind: true, steelSerpent: true, sterlingSovereignty: true, tempestGale: true, thrashingDragon: true, unquietGrave: true, veiledMoon: true,}
        }
    },
    {
        item:"Maneuver From School",
        storeType:"spells/maneuvers",
        price:60,
        defaultAmount:6,
        canBeSpecific:false,
    },
    {
        item:"Typed Maneuver",
        storeType:"spells/maneuvers",
        price:60,
        defaultAmount:2,
        canBeSpecific:false,
    },
    {
        item:"Maneuver Trade Up",
        storeType:"spells/maneuvers",
        price:0,
        defaultAmount:6,
        canBeSpecific:false,
        desc:`Trade 3 maneuvers for a typed maneuver of higher level, or 3 maneuvers from the same school for a finisher of that school.`
    },
    {
        item:"Level Up",
        storeType:"character",
        price:300,
        defaultAmount:2,
        canBeSpecific:false,
    },
    {
        item:"Night's Stay",
        storeType:"gear",
        price:500,
        defaultAmount:1,
        canBeSpecific:false,
        desc:`You can purchase a Night's Stay to increase your time in the store to 8 hours. This does not restore any hit points or spell points, but it does allow for 4800 rounds to drink potions, use spells, make checks, etc.`,
    },
    {
        item:"Rent",
        storeType:"gear",
        price:100,
        defaultAmount:2,
        canBeSpecific:false,
        desc:`Increase your party's rounds in the shop by 1.`,
    },
    {
        item:"Gambling",
        storeType:"gear",
        price:50,
        defaultAmount:4,
        canBeSpecific:false,
        desc:`Gamble your gold. Maybe for more gold, maybe for less. Maybe for something entirely new and rare.`,
    },
    {
        item:"wonderousItems",
        storeType:"gear",
        price:100,
        defaultAmount:8,
        canBeSpecific:true,
        canBeTyped:true,
        specificType:"wonderousItems",
        typesArr:{ring: false, neck:false, eyes:false, belt:false, hands:false, wrist:false, shoulders:false, chest:false, headband:false, body:false, feet:false, head:false,untyped:false},
        options:{ 
            rarity:{ common: true, rare: true, epic: true, legendary: true, unique:true},             
            type:{ ring: true, neck:true, eyes:true, belt:true, hands:true, wrist:true, shoulders:true, chest:true, headband:true, body:true, feet:true, head:true,untyped:true}
        }
    },
    {
        item:'Gear',
        storeType:"gear",
        price:25,
        defaultAmount:8,
        canBeSpecific:false,
    },
    {
        item:'Specific Gear',
        storeType:"gear",
        specific:true,
        specificType:"gear",
        canBeSpecific:true,
        typesArr:{ammunition:false, grenade:false, blanch:false, utility:false, implement:false},
        options:{type:{ammunition:true, grenade:true, blanch:true, utility:true, implement:true}},
        price:50,
        defaultAmount:8,
    },
    {
    item:'potion of minor mnemonic enhancement',
    price:10,
    potionId:1,
    defaultAmount:0,
    type:"mnemonic",
    },
    {
    item:'potion of lesser mnemonic enhancement',
    price:10,
    potionId:2,
    defaultAmount:0,
    type:"mnemonic",
    },
    {
    item:'potion of moderate mnemonic enhancement',
    price:10,
    potionId:3,
    defaultAmount:0,
    type:"mnemonic",
    },
    {
    item:'potion of improved mnemonic enhancement',
    price:10,
    potionId:4,
    defaultAmount:0,
    type:"mnemonic",
    },
    {
    item:'potion of greater mnemonic enhancement',
    price:10,
    potionId:5,
    defaultAmount:0,
    type:"mnemonic",
    },
    {
    item:'potion of epic mnemonic enhancement',
    price:10,
    potionId:6,
    defaultAmount:0,
    type:"mnemonic",
    },
    {
    item:'potion of legendary mnemonic enhancement',
    price:10,
    potionId:7,
    defaultAmount:0,
    type:"mnemonic",
    },
    {
    item:'potion of mythic mnemonic enhancement',
    price:10,
    potionId:8,
    defaultAmount:0,
    type:"mnemonic",
    },
    {
    item:'Ether',
    price:10,
    potionId:9,
    defaultAmount:0,
    type:"mnemonic",
    },
    {
    item:'potion of cure minor wounds',
    price:10,
    potionId:10,
    defaultAmount:0,
    type:"curative",
    },
    {
    item:'potion of cure light wounds',
    price:10,
    potionId:11,
    defaultAmount:0,
    type:"curative",
    },
    {
    item:'potion of cure moderate wounds',
    price:10,
    potionId:12,
    defaultAmount:0,
    type:"curative",
    },
    {
    item:'potion of cure serious wounds',
    price:10,
    potionId:13,
    defaultAmount:0,
    type:"curative",
    },
    {
    item:'potion of cure critical wounds',
    price:10,
    potionId:14,
    defaultAmount:0,
    type:"curative",
    },
    {
    item:'potion of cure devistating wounds',
    price:10,
    potionId:15,
    defaultAmount:0,
    type:"curative",
    },
    {
    item:'potion of Legendary Bodily Repair',
    price:10,
    potionId:16,
    defaultAmount:0,
    type:"curative",
    },
    {
    item:'potion of Mythic Bodily Repair',
    price:10,
    potionId:17,
    defaultAmount:0,
    type:"curative",
    },
    {
    item:'Elixer',
    price:10,
    potionId:18,
    defaultAmount:0,
    type:"curative",
    },    
    {
    item:'potion of lesser restoration',
    price:20,
    potionId:19,
    defaultAmount:2,
    type:"restorative",
    },
    {
    item:'potion of moderate restoration',
    price:30,
    potionId:20,
    defaultAmount:2,
    type:"restorative",
    },
    {
    item:'potion of greater restoration',
    price:40,
    potionId:21,
    defaultAmount:0,
    type:"restorative",
    },
    {
    item:'potion of complete restoration',
    price:50,
    potionId:22,
    defaultAmount:0,
    type:"restorative",
    },
    {
    item:'potion of remove curse',
    price:30,
    potionId:23,
    defaultAmount:2,
    type:"restorative",
    },    
    {
    item:'potion of Remove Blindness/Deafness',
    price:20,
    potionId:24,
    defaultAmount:2,
    type:"restorative",
    },
    {
    item:'potion of Remove Sickness',
    price:30,
    potionId:25,
    defaultAmount:2,
    type:"restorative",
    },
    {
    item:'potion of Remove Poison',
    price:20,
    potionId:26,
    defaultAmount:2,
    type:"restorative",
    },
    {
    item:'potion of Remove Paralysis',
    price:35,
    potionId:27,
    defaultAmount:2,
    type:"restorative",
    },
    {
    item:'Potion of Clear Mind',
    price:30,
    potionId:28,
    defaultAmount:2,
    type:"restorative",
    },
    {
    item:'potion of Dispelling',
    price:50,
    potionId:29,
    defaultAmount:2,
    type:"restorative",
    },
    {
    item:'potion of Panacea',
    price:75,
    potionId:30,
    defaultAmount:2,
    type:"restorative",
    },
    {
    item:'Angels Tears',
    price:100,
    potionId:31,
    defaultAmount:0,
    type:"restorative",
    },
    {
    item:'Divine Essence',
    price:150,
    potionId:32,
    defaultAmount:0,
    type:"restorative",
    },
    {
    item:'Gem of Breathe of life',
    price:100,
    potionId:33,
    defaultAmount:2,
    type:"ressurective",
    },
    {
    item:'Gem of Raise Dead',
    price:100,
    potionId:34,
    defaultAmount:1,
    type:"ressurective",
    },
    {
    item:'Gem of Ressurection',
    price:150,
    potionId:35,
    defaultAmount:0,
    type:"ressurective",
    },
    {
    item:'Gem of True Ressurection',
    price:200,
    potionId:36,
    defaultAmount:0,
    type:"ressurective",
    },
]

export const storePrices = [
    10, 15,	25,	50,	75,	100, 125, 150, 200, 250, 325, 450

]